import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import VoteItem from './VoteItem';
import { itemFieldChange } from '../actions';

const mapStateToProps = (state, ownProps) => ownProps;

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (field, value, isFormField) => {
    const { item } = queryString.parse(ownProps.location.search);

    return dispatch(
      itemFieldChange(
        ownProps.match.params.appname,
        ownProps.component.lazy_data,
        ownProps.component.type,
        item,
        field,
        value,
        null,
        null,
        isFormField,
      ),
    );
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VoteItem),
);
